<template>
  <footer>
    <span>&copy; Gurunavi, Inc.</span>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="postcss" scoped>
footer {
  align-items: center;
  background: #fff;
  border-top: solid 1px var(--border-color);
  box-sizing: border-box;
  display: flex;
  font-size: 14px;
  height: 32px;
  justify-content: center;
  line-height: 1.2;
}
</style>
